import styles from './Layouters.module.scss';

import { TpDashboardElement, TpDashboardContext, TpDashboardTabberDefinition } from '../dashboard/interfaces';
import { TpDataContext } from '../../../data/interfaces';
import { renderDashboardElement } from '../dashboard/render-elem';
import { useAppDispatch } from '../../../app/hooks';
import { ElementEditTools } from '../dashboard/edit-mode/ElementEditTools';
import Tabber from '../../../components/panels/tabber/Tabber';

interface TpDashboardTabberProps {
  parentElemDef: TpDashboardElement | null;
  dataContext: TpDataContext;
  dashboardContext: TpDashboardContext;
  elemDef: TpDashboardTabberDefinition;
}

export function DashboardTabberLayout({
  dataContext,
  parentElemDef,
  elemDef,
  dashboardContext,
}: TpDashboardTabberProps) {
  const dispatch = useAppDispatch();

  const style: any = {};
  if (dashboardContext.editMode) {
    style.border = '1px dashed rgb(255,128,0)';
    style.boxSizing = 'border-box';
    style.margin = '5px';
  }

  function getTabTitle(tabIdx: number): string {
    if (tabIdx < elemDef.tabTitles.length) return elemDef.tabTitles[tabIdx];
    return `Tab ${tabIdx + 1}`;
  }

  const dashboardContextChild = { ...dashboardContext, elementVerticalSizeOffset: 53 };

  // Special tabIds because the actionButtons element does not have a id property
  return (
    <div className={styles.tabberWrapper} style={style}>
      <Tabber
        tabIds={elemDef.elements.map((_, idx) => `tab_${idx}`)}
        getHeader={(tabId) => {
          const tabIdx = parseInt(tabId.split('_')[1]);
          return getTabTitle(tabIdx);
        }}
        renderContent={(tabId) => {
          const tabIdx = parseInt(tabId.split('_')[1]);
          return renderDashboardElement(elemDef, elemDef.elements[tabIdx], dataContext, dashboardContextChild);
        }}
        titlesSingleLine={true}
      />
      {dashboardContext.editMode && (
        <ElementEditTools
          dataContext={dataContext}
          dashboardContext={dashboardContextChild}
          parentElemDef={parentElemDef}
          elemDef={elemDef}
          dispatch={dispatch}
        />
      )}
    </div>
  );
}
